"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VidyardLevelNames = exports.VIDYARD_LOAD_STATUS = exports.VIDYARD_LIBRARY_LINK = exports.VideoType = exports.VIDEO_TYPE_VIDYARD = exports.VIDEO_TYPE_EMBED = exports.VIDEO_TYPE_DISABLED = exports.videoHostValidationRule = exports.AllowedVideoDomains = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _videoHostValidationR;

var AllowedVideoDomains;
exports.AllowedVideoDomains = AllowedVideoDomains;

(function (AllowedVideoDomains) {
  AllowedVideoDomains["youtube"] = "youtube.com";
  AllowedVideoDomains["wistiaNet"] = "wistia.net";
  AllowedVideoDomains["wistiaCom"] = "wistia.com";
  AllowedVideoDomains["vidyard"] = "vidyard.com";
  AllowedVideoDomains["vimeo"] = "vimeo.com";
})(AllowedVideoDomains || (exports.AllowedVideoDomains = AllowedVideoDomains = {}));

var videoHostValidationRule = (_videoHostValidationR = {}, (0, _defineProperty2["default"])(_videoHostValidationR, AllowedVideoDomains.youtube, 'https://www.youtube.com/embed/'), (0, _defineProperty2["default"])(_videoHostValidationR, AllowedVideoDomains.wistiaNet, ['https://fast.wistia.net/embed/', 'https://fast.wistia.com/embed/']), (0, _defineProperty2["default"])(_videoHostValidationR, AllowedVideoDomains.wistiaCom, ['https://fast.wistia.net/embed/', 'https://fast.wistia.com/embed/']), (0, _defineProperty2["default"])(_videoHostValidationR, AllowedVideoDomains.vidyard, 'https://play.vidyard.com/'), (0, _defineProperty2["default"])(_videoHostValidationR, AllowedVideoDomains.vimeo, 'https://player.vimeo.com/'), _videoHostValidationR); // TODO: Get rid this constants after moving all video components to TS.

exports.videoHostValidationRule = videoHostValidationRule;
var VIDEO_TYPE_DISABLED = 'disabled';
exports.VIDEO_TYPE_DISABLED = VIDEO_TYPE_DISABLED;
var VIDEO_TYPE_EMBED = 'embed';
exports.VIDEO_TYPE_EMBED = VIDEO_TYPE_EMBED;
var VIDEO_TYPE_VIDYARD = 'vidyard';
exports.VIDEO_TYPE_VIDYARD = VIDEO_TYPE_VIDYARD;
var VideoType;
exports.VideoType = VideoType;

(function (VideoType) {
  VideoType["DISABLED"] = "disabled";
  VideoType["EMBED"] = "embed";
  VideoType["VIDYARD"] = "vidyard";
})(VideoType || (exports.VideoType = VideoType = {}));

var VIDYARD_LIBRARY_LINK = 'https://app.vidyard.com/v1/embed.js';
exports.VIDYARD_LIBRARY_LINK = VIDYARD_LIBRARY_LINK;
var VIDYARD_LOAD_STATUS = {
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
};
exports.VIDYARD_LOAD_STATUS = VIDYARD_LOAD_STATUS;
var VidyardLevelNames;
exports.VidyardLevelNames = VidyardLevelNames;

(function (VidyardLevelNames) {
  VidyardLevelNames["GiftingFlow"] = "giftingFlow";
  VidyardLevelNames["CampaignSettings"] = "campaignSettings";
})(VidyardLevelNames || (exports.VidyardLevelNames = VidyardLevelNames = {}));